var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"global-message-container"},_vm._l((_vm.messages),function(message){return _c('p',{class:"alert alert-" + message.type + " alert-dismissible"},[_vm._v("\n\t\t\t"+_vm._s(message.content)+"\n\t\t\t"),_c('a',{staticClass:"close",attrs:{"href":"#","data-dismiss":"alert","aria-label":"close"}},[_vm._v("×")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }